import { NotifyHelper } from "../../../helpers/toast";
import { eThuPhiTabActionsDefine } from "../../action-types/thu-phi-tabs/IThuPhiTabActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const thuPhiTabAction = {
    ...generateActions(eThuPhiTabActionsDefine, "THU_PHI_TAB"),
    ...generateActionForKey(eThuPhiTabActionsDefine, "THU_PHI_TAB", "CREATE_THUPHI_SUCCCESS", () => { NotifyHelper.Success("Thành công") }),
}